import React, { Component } from 'react';
export default ({ name, style = {}, className = '' }) => (<i className={`Icon material-icons ${className}`} style={style}>{name}</i>);
